const getDateTime = (timestamp) => {
  if (timestamp === "0001-01-01T00:00:00Z" || timestamp === "") {
    return "-";
  }

  // Parse timestamp menggunakan objek Date
  const date = new Date(timestamp);

  // Dapatkan waktu, tanggal, dan bulan
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const day = date.getUTCDate();
  const month = date.getUTCMonth() + 1; // Tambahkan 1 karena bulan dimulai dari 0 (Januari)

  // Format waktu dan tanggal sesuai dengan kebutuhan
  const formattedTime = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
  const formattedDate = `${date.getUTCFullYear()}/${month < 10 ? '0' : ''}${month}/${day < 10 ? '0' : ''}${day}`;

  // Gabungkan waktu dan tanggal
  const formattedDateTime = `${formattedTime} WIB | ${formattedDate}`;

  return formattedDateTime;
};

export default getDateTime;